<template>
  <article class="checkpoint-past-version-card" data-testid="checkpoint-past-version-card">
    <div class="checkpoint-past-version-card__inner">
      <header class="checkpoint-past-version-card__header">
        <Breadcrumbs :breadcrumbsList="breadcrumbs" @onClickBreadcrumb="onBreadcrumbClick" />
      </header>

      <CheckpointEditFormV2
        class="checkpoint-past-version-card__form"
        past-version-view
        :checkpoint="checkpoint"
        :responsibility-id="responsibilityId"
        :responsibility-name="responsibilityName"
        :responsibility-code="responsibilityCode"
        :responsibility-purpose="responsibilityPurpose"
        v-on="$listeners"
      />
    </div>
  </article>
</template>

<script setup>
import { computed } from "vue";
import Breadcrumbs from "@components/breadcrumbs/ExBreadcrumbs.vue";
import CheckpointEditFormV2 from "@components/CheckpointEditFormV2/CheckpointEditFormV2.vue";

const props = defineProps({
  /** Version snapshot payload — same shape as CheckpointEditFormV2 `checkpoint`. */
  checkpoint: {
    type: Object,
    required: true,
  },
  /** Shown as the active breadcrumb pill, e.g. `3` → "Version 3". */
  versionNumber: {
    type: [Number, String],
    required: true,
  },
  responsibilityId: {
    type: [String, Number],
    default: null,
  },
  responsibilityName: {
    type: String,
    default: "",
  },
  responsibilityCode: {
    type: String,
    default: "",
  },
  responsibilityPurpose: {
    type: String,
    default: "",
  },
  checklistBreadcrumbLabel: {
    type: String,
    default: "Checklist",
  },
  checkpointBreadcrumbLabel: {
    type: String,
    default: "Checkpoint",
  },
});

const emit = defineEmits(["breadcrumb-click"]);

const versionBreadcrumbLabel = computed(() => `Version ${props.versionNumber}`);

const breadcrumbs = computed(() => [
  {
    text: props.checklistBreadcrumbLabel,
    href: "",
  },
  {
    text: props.checkpointBreadcrumbLabel,
    href: "",
  },
  {
    text: versionBreadcrumbLabel.value,
    href: "",
    disabled: true,
  },
]);

function onBreadcrumbClick(breadcrumb) {
  emit("breadcrumb-click", breadcrumb);
}
</script>

<style scoped>
.checkpoint-past-version-card {
  box-sizing: border-box;
  width: 100%;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 8px;
  box-shadow:
    0 1px 3px 0 rgba(16, 24, 40, 0.1),
    0 1px 2px 0 rgba(16, 24, 40, 0.06);
  overflow: hidden;
}

.checkpoint-past-version-card__inner {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.checkpoint-past-version-card__header {
  padding: 19px 17px 0;
}

.checkpoint-past-version-card__form {
  padding-top: 0;
}

.checkpoint-past-version-card__header :deep(.ex-breadcrumbs .v-breadcrumbs__item) {
  font-size: 12px;
}
</style>
